import { useState, useEffect } from 'react';

/**
 * Returns scroll direction: 'up' | 'down' | null (before first scroll)
 */
export function useScrollDirection(threshold = 10) {
  const [direction, setDirection] = useState(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    let lastY = window.scrollY;

    const onScroll = () => {
      const currentY = window.scrollY;
      setScrollY(currentY);

      if (Math.abs(currentY - lastY) < threshold) return;

      setDirection(currentY > lastY ? 'down' : 'up');
      lastY = currentY > 0 ? currentY : 0;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return { direction, scrollY };
}
